import React from 'react';
import ParticlesComponent from '../../Hosting/Particle';
import BannerWrapper from './banner.style';

const BannerSection = () => {
  return (
    <BannerWrapper id="banner_section">
      <ParticlesComponent />
    </BannerWrapper>
  );
};

export default BannerSection;
